import React, { useState } from "react";

import { urlService } from "services";
import { ActiveToolFacetType, IToolFacet } from "types";
import { useOnPersistedPageShow } from "utils";

import { ToolQuickSearchForm } from "../components";

interface ToolSearchAppProps {
  facets: IToolFacet[];
}

export const ToolQuickSearchContainer: React.FC<ToolSearchAppProps> = ({
  facets,
}) => {
  const [isLoading, setLoading] = useState(false);

  // bfcache fix
  useOnPersistedPageShow(() => setLoading(false));

  const handleSubmit = (data: ActiveToolFacetType) => {
    setLoading(true);

    // redirect to tool search single with chosen facets
    window.location.href = urlService.generateToolSearchUrl(data);
  };
  return (
    <div className="tool-quick-search">
      <ToolQuickSearchForm
        facets={facets}
        onSubmit={handleSubmit}
        isLoading={isLoading}
      />
    </div>
  );
};
